import {Enum} from '../../common/model/enum.model';

export class CategoriaGerarchia extends Enum {

  constructor(protected value: string) {
    super(value);
  }

  public static values(): CategoriaGerarchia[] {
    return [
      new CategoriaGerarchia('SEDI'),
      new CategoriaGerarchia('PROGETTI'),
      new CategoriaGerarchia('CONTABILE'),
      new CategoriaGerarchia('ORGANIZZATIVA')
    ];
  }

}
